/**
 * CMToast - Enterprise Toast Notification System
 * Highend live notifications (bottom-right)
 */

const CMToast = {
    container: null,
    queue: [],
    isVisible: false,
    currentTimeout: null,

    init() {
        this.createContainer();
        this.bindEvents();
    },

    createContainer() {
        if (this.container) return;

        this.container = document.createElement('div');
        this.container.className = 'cm-toast-container';
        document.body.appendChild(this.container);
    },

    bindEvents() {
        document.addEventListener('click', (e) => {
            const toast = e.target.closest('.cm-toast');
            if (!toast) return;

            const action = e.target.closest('[data-toast-action]');
            if (action) {
                const actionType = action.dataset.toastAction;
                if (actionType === 'view-cart') {
                    window.location.href = action.dataset.cartUrl || '/warenkorb/';
                } else if (actionType === 'dismiss') {
                    this.dismissToast(toast);
                }
            }
        });
    },

    show(message, type = 'info', options = {}) {
        const {
            duration = 4000,
            showCartLink = false,
            cartUrl = null,
            showCloseBtn = false
        } = options;

        const toast = document.createElement('div');
        toast.className = `cm-toast cm-toast--${type}`;
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'polite');

        const iconSvg = this.getIcon(type);
        
        let actionsHtml = '';
        if (showCartLink) {
            actionsHtml = `
                <div class="cm-toast__actions">
                    <button class="cm-toast__action cm-toast__action--primary" data-toast-action="view-cart" data-cart-url="${cartUrl || ''}">
                        Warenkorb anzeigen
                    </button>
                    ${showCloseBtn ? `<button class="cm-toast__action cm-toast__action--secondary" data-toast-action="dismiss">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>` : ''}
                </div>
            `;
        } else if (showCloseBtn) {
            actionsHtml = `
                <button class="cm-toast__close" data-toast-action="dismiss" aria-label="Schließen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            `;
        }

        toast.innerHTML = `
            <div class="cm-toast__icon">
                ${iconSvg}
            </div>
            <div class="cm-toast__content">
                <p class="cm-toast__message">${message}</p>
                ${actionsHtml}
            </div>
        `;

        this.container.appendChild(toast);

        requestAnimationFrame(() => {
            toast.classList.add('cm-toast--visible');
        });

        if (duration > 0) {
            setTimeout(() => {
                this.dismissToast(toast);
            }, duration);
        }
    },

    getIcon(type) {
        const icons = {
            success: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>`,
            error: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>`,
            warning: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>`,
            info: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>`
        };
        return icons[type] || icons.info;
    },

    dismissToast(toast) {
        if (!toast || !toast.parentNode) return;

        toast.classList.remove('cm-toast--visible');
        toast.classList.add('cm-toast--hiding');

        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 300);
    },

    dismissAll() {
        const toasts = this.container.querySelectorAll('.cm-toast');
        toasts.forEach(toast => this.dismissToast(toast));
    }
};

window.CMToast = CMToast;

document.addEventListener('DOMContentLoaded', () => {
    CMToast.init();
});

export default CMToast;
